module.exports = __webpack_public_path__ + "static/media/sv.4dd6d709.svg";